import CMMILevel3 from "@/assets/cmmi-level-3-badge-BSa7Q4e9.png";
import ISO27001 from "@/assets/iso-27001-badge-CQ6tote3.png";
import ISO9001 from "@/assets/iso-9001-badge-C3ypBXVO.png";

const FloatingCertifications = () => {
  return (
    <>
      {/* Badge 1 */}
      <div
        className="floating-badge absolute z-30 flex flex-col items-center animate-[float-slow_18s_ease-in-out_infinite]"
        style={{ top: "15%", left: "4%" }}
      >
        <div className="relative group">
          <div className="glow-orange" />

          <div className="relative  rounded-2xl p-3 transition-all duration-500 group-hover:scale-105">
            <div className="coin-shine rounded-xl">
              <img
                src={CMMILevel3}
                alt="CMMI Level 3 Certified"
                className="h-20 w-20 mx-auto rounded-xl"
              />
            </div>

            <p className="mt-2 w-full text-center text-sm font-semibold text-white bg-gradient-to-r from-primary to-primary-glow px-4 py-1.5 rounded-full shadow-glow">
              CMMI Level 3
            </p>
          </div>
        </div>
      </div>

      {/* Badge 2 */}
      <div
        className="floating-badge absolute z-30 flex flex-col items-center animate-[float-reverse_22s_ease-in-out_infinite]"
        style={{ top: "22%", right: "8%" }}
      >
        <div className="relative group">
          <div className="glow-blue" />

          <div className="relative  rounded-2xl p-3 transition-all duration-500 group-hover:scale-105">
            <div className="coin-shine rounded-xl">
              <img
                src={ISO27001}
                alt="ISO 27001 Certified"
                className="h-20 w-20 object-contain mx-auto rounded-xl"
              />
            </div>

            <p className="mt-2 w-full text-center text-sm font-semibold text-white bg-gradient-to-r from-secondary to-secondary-glow px-4 py-1.5 rounded-full shadow-glow">
              ISO 27001
            </p>
          </div>
        </div>
      </div>

      {/* Badge 3 */}
      <div
        className="floating-badge absolute z-30 flex flex-col items-center animate-[float-slow_20s_ease-in-out_infinite]"
        style={{ bottom: "15%", left: "4%", transform: "translateX(-50%)" }}
      >
        <div className="relative group">
          <div className="glow-green" />

          <div className="relative  rounded-2xl p-3 transition-all duration-500 group-hover:scale-105">
            <div className="coin-shine rounded-xl">
              <img
                src={ISO9001}
                alt="ISO 9001 Certified"
                className="h-20 w-20 object-contain mx-auto rounded-xl"
              />
            </div>

            <p className="mt-2 w-full text-center text-sm font-semibold text-white bg-gradient-to-r from-success to-success/80 px-4 py-1.5 rounded-full shadow-glow">
              ISO 9001
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default FloatingCertifications;
